import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcExternal = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1341_37384)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M4 7.2318C4.01234 7.21123 4.0288 7.19271 4.03703 7.17111C4.16869 6.84401 4.41659 6.67121 4.77248 6.67121C6.00167 6.67018 7.23086 6.67018 8.46004 6.67018C10.0225 6.67018 11.585 6.66915 13.1474 6.67121C13.6946 6.67224 14.0557 7.16391 13.8736 7.66176C13.7728 7.93845 13.5712 8.10303 13.2739 8.13903C13.1814 8.15035 13.0867 8.15343 12.9931 8.15343C10.5605 8.15446 8.12883 8.15446 5.69617 8.15446C5.63034 8.15446 5.56451 8.15446 5.48942 8.15446C5.48942 11.5016 5.48942 14.827 5.48942 18.1618C8.82211 18.1618 12.1486 18.1618 15.4988 18.1618C15.4988 18.099 15.4988 18.0342 15.4988 17.9684C15.4988 15.6355 15.4988 13.3016 15.4988 10.9687C15.4988 10.5614 15.7004 10.2827 16.0584 10.188C16.4863 10.0738 16.9306 10.3865 16.9677 10.8288C16.9728 10.8906 16.9759 10.9533 16.9759 11.016C16.9759 13.6092 16.9749 16.2033 16.9779 18.7964C16.9779 19.1431 16.8771 19.4301 16.5459 19.573C16.4091 19.6327 16.2435 19.6471 16.0913 19.6471C12.9304 19.6512 9.76843 19.6502 6.60752 19.6502C6.05516 19.6502 5.5028 19.6348 4.95146 19.6553C4.49373 19.6718 4.16252 19.5237 4 19.0762C4 15.1284 4 11.1796 4 7.2318Z",
				fill: "#C6CCDA"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M18.453 6.5313C18.4222 6.58479 18.4026 6.64856 18.3605 6.69074C16.079 8.97528 13.7945 11.2578 11.513 13.5433C11.2764 13.7799 11.0131 13.8961 10.6829 13.7933C10.1964 13.6421 10.0133 13.0373 10.3301 12.6382C10.3815 12.5733 10.4412 12.5137 10.4998 12.4551C12.7751 10.1787 15.0514 7.90347 17.3277 5.62716C17.3668 5.58807 17.4039 5.54692 17.4656 5.48109C17.3792 5.48109 17.3247 5.48109 17.2701 5.48109C16.3691 5.48109 15.468 5.48315 14.567 5.48006C14.2419 5.47904 13.9714 5.27434 13.8747 4.9709C13.777 4.66644 13.8696 4.32699 14.139 4.15625C14.2759 4.06881 14.4569 4.01018 14.6184 4.00915C16.15 3.99784 17.6805 3.99887 19.2121 4.00504C19.7121 4.0071 20.0001 4.31157 20.0001 4.81147C20.0001 6.35335 20.0011 7.89421 19.999 9.43609C19.998 9.80845 19.7193 10.116 19.3551 10.1643C18.9931 10.2117 18.6423 9.9792 18.5508 9.61918C18.524 9.5153 18.522 9.40318 18.522 9.29414C18.5199 8.44554 18.5209 7.59591 18.5209 6.74731C18.5209 6.69177 18.5209 6.63622 18.5209 6.58068C18.4973 6.56319 18.4757 6.54673 18.453 6.5313Z",
				fill: "#C6CCDA"
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1341_37384",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 16,
				height: 15.6564,
				fill: "white",
				transform: "translate(4 4)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgIcExternal);
export default ForwardRef;
